import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Unit } from '../../shared/common/units';
import { FeaturePropertyKey } from '../../../projects/client';

@Component({
  selector: 'app-units-demo',
  templateUrl: './units-demo.component.html',
  styleUrls: ['./units-demo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitsDemoComponent implements OnInit {
  featurePropertyKey = FeaturePropertyKey;
  features: any[];

  constructor() {}

  ngOnInit(): void {
    const units = Object.values(Unit);
    this.features = units.map((unit) => this.getFeature(unit));
  }

  private getFeature(unit: Unit): any {
    return {
      feature: 'mock',
      isEnabled: true,
      isReady: true,
      properties: {
        value: {
          value: 50,
          unit,
          type: 'number',
        },
      },
    };
  }
}
